import React, { createRef } from 'react';

import { Box, createStyles, makeStyles, Theme, useTheme } from '@material-ui/core';
import { SnackbarKey, SnackbarProvider } from 'notistack';
import { VscClose } from 'react-icons/vsc';

const snackBarStyles = {
  borderRadius: '12px',
  boxShadow: 'none',
  maxWidth: '1000px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '16px',
  paddingRight: '48px',
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    success: {
      backgroundColor: '#A6F787',
      color: theme.palette.text.primary,
      ...snackBarStyles,
    },
    error: {
      backgroundColor: '#FF75CB',
      color: theme.palette.text.primary,
      ...snackBarStyles,
    },
    warning: {
      backgroundColor: '#FFDF9A',
      color: theme.palette.text.primary,
      ...snackBarStyles,
    },
    info: {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      border: `1px solid ${theme.palette.divider}`,
      ...snackBarStyles,
    },
  })
);

interface Props {
  children: React.ReactElement;
}

export const AppSnackbarProvider: React.FC<Props> = ({ children }) => {
  const theme = useTheme();
  const notistackRef: any = createRef();
  const classes = useStyles();

  const onClickDismiss = (key: SnackbarKey) => () => {
    notistackRef?.current?.closeSnackbar(key);
  };

  return (
    <SnackbarProvider
      hideIconVariant
      ref={notistackRef}
      maxSnack={3}
      classes={{
        variantSuccess: classes.success,
        variantError: classes.error,
        variantWarning: classes.warning,
        variantInfo: classes.info,
      }}
      action={key => (
        <Box
          style={{ cursor: 'pointer', position: 'absolute', right: '16px', top: '16px' }}
          onClick={onClickDismiss(key)}>
          <VscClose size="15px" color={theme.palette.text.secondary} />
        </Box>
      )}>
      {children}
    </SnackbarProvider>
  );
};
